import { FunctionComponent, useEffect, useState } from 'react';
import Parser from 'html-react-parser';
import { Box, Card, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { createPortal } from 'react-dom';
import l from '../../../../lang';
import './styles.scss';
import TableInfo from '../../../common/table-info';
import { SplitPayment } from '../../../../store/split-payments/interfaces';
import ExportTransactions from '../export';
import ButtonLink from '../../../common/button-link';
import Dialog from '../../../common/dialog';
import { Button } from '../../../common/button';

interface ChargebackDrawerProps {
  onClose: () => void;
  data: any;
}

const SplitContractDrawer: FunctionComponent<ChargebackDrawerProps> = ({
  onClose,
  data,
}: {
  onClose: () => void;
  data: SplitPayment;
}) => {
  const [showSplitTerms, setShowSplitTerms] = useState(false);

  return createPortal(
    <div className="split_drawer">
      <Card className={`split_drawer__content`} onClick={ev => ev.stopPropagation()}>
        <div className="split_drawer__content__header">
          <div></div>
          <IconButton className="split_drawer__content__close" onClick={onClose}>
            <CloseIcon color="action" />
          </IconButton>
        </div>
        <div className="split_drawer__content__body">
          <h3>{l('splitDrawer.title')}</h3>
          <h2 style={{ marginBottom: '40px' }}>{l('splitDrawer.subtitle')}</h2>
          <TableInfo
            rows={[
              {
                label: l('splitDrawer.table.collaborator'),
                value: data.collaboratorFantasyName,
              },
              {
                label: l('splitDrawer.table.seller'),
                value: data.sellerFantasyName,
              },
              {
                label: l('splitDrawer.table.type'),
                value: l(`split_payments.creation.category.${data.category.toLowerCase()}`),
              },
              {
                label: l('splitDrawer.table.commission'),
                value: data.collaboratorCommission.toFixed(2) + '%',
              },
              {
                label: <ButtonLink onClick={() => setShowSplitTerms(true)} text={l('splitDrawer.table.termsOfUse')} />,
                value: '',
              },
            ]}
          />
          <div className="export-transactions">
            <div className="export-transactions__button">
              <ExportTransactions splitData={data} />
            </div>
          </div>
          {showSplitTerms && (
            <Dialog
              type="lg"
              title={l('split_payments.creation.menu.terms_and_conditions')}
              body={Parser(l('split_payments.terms_and_conditions.body'))}
              footer={
                <Box sx={{ padding: '20px', display: 'flex', justifyContent: 'center', width: '100%' }}>
                  <Button size="large" onClick={() => setShowSplitTerms(false)}>
                    {l('common.close')}
                  </Button>
                </Box>
              }
              handleClose={() => setShowSplitTerms(false)}
            />
          )}
        </div>
      </Card>
    </div>,
    window.document.body
  );
};

export default SplitContractDrawer;
